
export default function WhyChooseUs() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Quality Guaranteed',
      description: 'Every tire at Seneca Tire Shop is thoroughly inspected and comes with our quality guarantee for your peace of mind.'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Competitive Pricing',
      description: 'Best prices on new and used tires in the area with flexible payment options and special promotions.'
    },
    {
      icon: 'ri-team-line',
      title: 'Expert Technicians',
      description: 'Our certified tire specialists have years of experience providing professional service and expert advice.'
    },
    {
      icon: 'ri-time-line',
      title: 'Fast Service',
      description: 'Quick turnaround times with same-day installation available for most tire purchases and services.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Customer Support',
      description: 'Dedicated customer service team ready to help you find the perfect tires for your vehicle and budget.'
    },
    {
      icon: 'ri-award-line',
      title: 'Trusted Brands',
      description: 'We carry top tire brands including Michelin, Goodyear, Bridgestone, Continental, and many more.'
    }
  ];

  return (
    <section id="about" className="py-20 bg-zinc-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Why Choose Seneca Tire Shop
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Your trusted tire partner for quality products, expert service, and unbeatable value
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-zinc-800 p-8 rounded-xl hover:bg-zinc-750 transition-colors cursor-pointer"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-red-600 rounded-full mb-6">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">{feature.title}</h3>
              <p className="text-gray-300 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
